import Paragraph from './paragraph'
import Heading from './heading'
import Link from './link'
import Code from './code'
import Button from './button'

const TYPES_MAP = {
  'rich_text/paragraph': Paragraph,
  'rich_text/h1': Heading,
  'rich_text/h2': Heading,
  'rich_text/h3': Heading,
  'rich_text/h4': Heading,
  'rich_text/h5': Heading,
  'rich_text/h6': Heading,
  'rich_text/link': Link,
  'rich_text/code': Code,
  'rich_text/button': Button,
}

export {TYPES_MAP, Paragraph, Heading, Link, Code, Button }


// WEBPACK FOOTER //
// ./app/javascript/app/site/components/content/rich_text/index.js